module.exports = __webpack_public_path__ + "img/event_mobile_xs_6.240352a2.png";